import { Controller } from "stimulus"

import Clipboard from 'clipboard';


export default class extends Controller {

  initialize() {
    
    console.log("Loaded api-keys/index_controller.js")
    this.setupClipboard()
  }

  setupClipboard() {
    var notyf = new Notyf( {
      position: {
      x: 'right',
      y: 'top',
    }
  });

    const clipboard = new Clipboard('.btnclipboard');  
    clipboard.on('success', (e) => {
      notyf.success('Copied to clipboard');
      e.clearSelection();
    });

    clipboard.on('error', (e) => {
      notyf.error('Failed to copy to clipboard');
    });
  }
} 
